<template>
	<div class="project-name">
		<v-layout row>
			<h1>Projekt ({{value}})</h1>
			<v-icon
				v-if="!readonly"
				small
				@click="renameOpen = true"
			>edit
			</v-icon>
			<egranty-input-field-popup
				:is-open.sync="renameOpen"
				:default-value="value"
				field-type="LONG_TEXT"
				long
				label="nowa nazwa"
				for="project-name-new-name"
				title="Zmień nazwę projektu"
				@save="rename"
			></egranty-input-field-popup>
		</v-layout>
		<br>
	</div>
</template>

<script>
	import EgrantyInputFieldPopup from "../../../../genericComponents/EgrantyInputFieldPopup";

	export default {
		name: "ProjectName",
		components: {EgrantyInputFieldPopup},
		methods: {

			rename(val) {
				if (val === "" || val === undefined || val === null) {
					return;
				}
				this.$emit("input", val);
				this.renameOpen = false;
			},

		},

		data() {
			return {
				renameOpen: false,
			};
		},

		props: {
			value: {},
			readonly: {
				type: Boolean, default: false
			}
		},
	};
</script>

<style scoped>
	.project-name h1 {
		margin-left: 20px;

	}
</style>
